export const BUILD_TIMESTAMP = '2025-12-31T01:59:43Z';
